import React from 'react';
import { Download, Filter, Upload } from 'lucide-react';

interface LeadsPageHeaderProps {
  onToggleFilters: () => void;
  onExportCSV: () => void;
  onImportCSV: () => void;
  hasLeads: boolean;
  filtersOpen?: boolean;
}

const LeadsPageHeader: React.FC<LeadsPageHeaderProps> = ({
  onToggleFilters,
  onExportCSV,
  onImportCSV,
  hasLeads,
  filtersOpen
}) => {
  const filterToggleClasses = filtersOpen
    ? 'text-bordo border-bordo/40 bg-bordo/8'
    : 'text-tinta-soft bg-white border-tinta/15 hover:bg-creme-light hover:text-tinta';

  return (
    <div className="sm:flex sm:items-end sm:justify-between gap-4">
      <div>
        <h1 className="font-display text-3xl font-black text-tinta leading-tight">
          Seus <span className="italic text-bordo">clientes</span>
        </h1>
        <p className="mt-2 text-sm text-tinta-soft">
          Gerencie todos os participantes que giraram suas rodas de prêmios
        </p>
      </div>
      <div className="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-2">
        <button
          onClick={onToggleFilters}
          className={`w-full sm:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-bold border transition-colors ${filterToggleClasses}`}
        >
          <Filter className="mr-2 h-4 w-4" />
          Filtros
        </button>
        <button
          onClick={onImportCSV}
          className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-bold text-tinta bg-mostarda hover:bg-mostarda-light border border-mostarda-dark/30 transition-colors"
        >
          <Upload className="mr-2 h-4 w-4" />
          Importar CSV
        </button>
        <button
          onClick={onExportCSV}
          disabled={!hasLeads}
          className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Download className="mr-2 h-4 w-4" />
          Exportar CSV
        </button>
      </div>
    </div>
  );
};

export default LeadsPageHeader;
